export const SET_KPI_ENTRIES_LOADED = "SET_KPI_ENTRIES_LOADED";

export const setKpiEntriesLoaded = (kpiEntriesLoaded: boolean) => {
  return {
    kpiEntriesLoaded,
    type: SET_KPI_ENTRIES_LOADED
  };
};
